import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = [
    'container',
    'listbox',
    'input',
  ];

  connect() {
    this.closeAll();
    useClickOutside(this, { element: this.containerTarget });
  }

  clickOutside = (event) => {
    if (this.listboxTarget.contains(event.target)) return;
    this.closeAll();
  };

  apply(event) {
    const url = new URL(window.location.href);

    const attributes = new Set();
    this.inputTargets.forEach((checkbox) => {
      attributes.add(checkbox.name);
    });

    attributes.forEach((attr) => url.searchParams.delete(attr));

    this.inputTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        url.searchParams.append(checkbox.name, checkbox.value);
      }
    });

    this.closeAll();

    const { controlledBy } = event.target.closest('[role="listbox"]').dataset;
    document.getElementById(controlledBy).focus();

    Turbo.visit(url);
  }

  clear(event) {
    const listbox = event.currentTarget.closest('[role="listbox"]');
    if (listbox) {
      listbox.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false;
      });
    }
  }

  toggle = (event) => {
    const button = event.currentTarget;
    const filter = document.getElementById(button.getAttribute('aria-controls'));
    const open = !filter.hidden;

    this.closeAll();

    filter.hidden = open;
    button.setAttribute('aria-expanded', !open);
  };

  closeAll = () => {
    this.listboxTargets.forEach((filter) => {
      const button = document.querySelector(`[aria-controls="${filter.id}"]`);
      filter.hidden = true;
      button.setAttribute('aria-expanded', false);
    });
  };
}
